import { Typography } from '@mui/material';
import { HeaderProvider } from '../contexts/HeaderProvider';
import { useAuthentication } from '../hooks/useAuthentication.ts';
import { ContentWithHeaderLayout } from './ContentWithHeaderLayout.tsx';

export const ContentWithHeaderRoute = () => {
  const { isLoading } = useAuthentication();

  if (isLoading) {
    return <Typography>Loading&hellip;</Typography>;
  }

  return (
    <HeaderProvider>
      <ContentWithHeaderLayout />
    </HeaderProvider>
  );
};
